const o = {
  fab: 1050,
  drawer: 1200,
  modal: 1300,
  notification: 1400,
  tooltip: 1500
};
export {
  o as default
};
